import './index.css';
import { createContext } from 'react';

const TableContext = createContext({
    headerNode: null,
    fontLoaded: false,
});

export { TableContext };
//# sourceMappingURL=context.js.map
